import React from 'react';
import { Spin } from 'antd';

import './Loader.sass';

const Loader = () => {
  return (
    <div className="container">
      <Spin size="small" />
    </div>
  );
};

export default Loader;
